import {
  collection, doc, setDoc, getDocs, getDoc, deleteDoc,
  query, where, serverTimestamp,
} from 'firebase/firestore';
import { db } from '../firebase';

// ─── Campaigns ────────────────────────────────────────────────────────────────

export const saveCampaign = async (campaign) => {
  const ref = campaign.id
    ? doc(db, 'campaigns', campaign.id)
    : doc(collection(db, 'campaigns'));

  await setDoc(ref, {
    ...campaign,
    id: ref.id,
    updatedAt: serverTimestamp(),
  }, { merge: true });

  return ref.id;
};

export const fetchCampaigns = async (uid) => {
  const q = query(collection(db, 'campaigns'), where('ownerId', '==', uid));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ ...d.data(), id: d.id }));
};

export const fetchCampaign = async (id) => {
  const snap = await getDoc(doc(db, 'campaigns', id));
  return snap.exists() ? { ...snap.data(), id: snap.id } : null;
};

export const deleteCampaign = async (id) => {
  await deleteDoc(doc(db, 'campaigns', id));
};

// ─── Social Connections (per user) ───────────────────────────────────────────

export const saveSocialConnection = async (uid, platform, tokenData) => {
  await setDoc(doc(db, 'socialConnections', uid), {
    [platform]: { ...tokenData, connectedAt: serverTimestamp() },
  }, { merge: true });
};

export const fetchSocialConnections = async (uid) => {
  const snap = await getDoc(doc(db, 'socialConnections', uid));
  return snap.exists() ? snap.data() : {};
};

export const removeSocialConnection = async (uid, platform) => {
  const ref = doc(db, 'socialConnections', uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return;
  const data = snap.data();
  delete data[platform];
  await setDoc(ref, data);
};
